'use strict';

var offcanvasdialog = require('../components/offcanvasdialog');
var progress = require('../utils/progress');
var keyCodes = require('../constants/key-codes');
var validInputIndicator = require('../validation/valid-input-indicator');
const friendlyCaptcha = require('../widgets/friendlyCaptcha');
const captcha = require('../spam/captcha');
const uniform = require('../components/uniform');

import {debounce} from '../components/custom-lodash';

const highlightTermsError = $newsletterContainer => {
    const $acceptTerms = $newsletterContainer.find('.accept-terms');
    $acceptTerms.find('.custom-checkbox-container').addClass('error');
    $acceptTerms.find('.checkbox-input').one('click', e => {
        $newsletterContainer
            .parent()
            .find('.status')
            .fadeOut(300, () => $(e.currentTarget).siblings('.custom-checkbox-container').removeClass('error'));
    });
};

const showTermsError = ($newsletterContainer, $insertBeforeElement) => {
    const message = $newsletterContainer.data('terms-not-accepted-msg');
    $('<div class="status message error-form">' + message + '</div>').insertBefore($insertBeforeElement);
    highlightTermsError($newsletterContainer);
};

function disableFlyinFlag() {
    var d = new Date();
    d.setTime(d.getTime() + 28 * 24 * 60 * 60 * 1000);
    if (document.cookie.indexOf('flyin_closed') < 0) {
        document.cookie = 'flyin_closed=1; path=/; expires=' + d.toUTCString();
    }
}

function initFlyinFlag($flyinFlag) {
    /**
     * If we have not accepted cookies yet, then show the notification
     */
    if ($flyinFlag.length > 0 && document.cookie.indexOf('flyin_closed') > -1) {
        $flyinFlag.hide();
    } else {
        $flyinFlag.addClass('open-animation');
    }

    $flyinFlag.find('.icon-close').on('click', e => {
        e.preventDefault();
        disableFlyinFlag();
        $flyinFlag.removeClass('open-animation no-open-animation').addClass('hide-animation');
    });
}

function isMobile() {
    return $(window).width() <= 767;
}

function isTablet() {
    return !isMobile() && $(window).width() <= 1023;
}

function getFlyinPosition($flyinFlag) {
    if (isTablet()) {
        return $flyinFlag.hasClass('tablet-right') ? 'right' : 'left';
    } else if (isMobile()) {
        return $flyinFlag.hasClass('mobile-right') ? 'right' : 'left';
    } else {
        return $flyinFlag.hasClass('desktop-right') ? 'right' : 'left';
    }
}

function validateNewsletterFlyinForm(
    $flyinContainer,
    $target,
    $closeIcon,
    flagActions,
    containerSelector,
    insertBeforeSelector
) {
    const $actionElement = $($target.currentTarget);
    const $form = $actionElement.closest('form');
    if (!$form.valid()) {
        return false;
    }
    $flyinContainer.find('.status.message').remove();
    const hasAcceptedTerms =
        $form.find('.js-accept-terms-hidden').length > 0
            ? true
            : $form.find('.accept-terms .checkbox-input').prop('checked');

    if (!hasAcceptedTerms) {
        showTermsError($form, $flyinContainer.find(insertBeforeSelector));
        return;
    }

    const url = $form.attr('action');
    const email = $form.find('.input-email').val();

    const gender = $actionElement.attr('value');
    const $genderInput = $form.find('.newsletter-gender');
    if ($genderInput.length) {
        $genderInput.val(gender);
    }

    progress.show($flyinContainer.find('.ocd-content'));
    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
        success: response => {
            const $container = $flyinContainer.find(containerSelector);

            if (response.success) {
                if ($closeIcon) {
                    $closeIcon.detach(); //keep close icon events
                }

                $container.html(response.msg);

                if ($flyinContainer.hasClass('fly-in-dialogue-avaliability')) {
                    $container.append(
                        '<div class="ocd-close availability-close" tabindex="0" aria-label="Close" role="button"><i class="icon icon-close" aria-hidden="true" tabindex="-1"></i></div>'
                    );
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'newsletterSignup_availabilityReminder',
                            newsletterSignupStep: 'NewsletterFlyin'
                        });
                    }
                }

                if ($closeIcon) {
                    $flyinContainer.find('.flyin-headline-3').append($closeIcon);
                }

                if (flagActions) {
                    $('.fly-in-flag:not(.layout-side-button)').remove();
                    disableFlyinFlag();
                }

                if (window.dataLayer && !$flyinContainer.hasClass('fly-in-dialogue-avaliability')) {
                    window.dataLayer.push({
                        event: 'newsletterSignup_flyIn',
                        newsletterSignupStep: 'NewsletterFlyin'
                    });
                }

                if (response.additionalText) {
                    $container.append(response.additionalText);
                }
            } else if (response.valueError) {
                $('<div class="status message error-form">' + response.valueError + '</div>').insertBefore(
                    $flyinContainer.find(insertBeforeSelector)
                );

                if (response.termsError) {
                    highlightTermsError($form);
                }
                captcha.resetCaptcha($form[0]);
            } else if (response.error) {
                if ($closeIcon) {
                    $closeIcon.detach(); //keep close icon events
                }

                $container.html(response.error);

                if ($flyinContainer.hasClass('fly-in-dialogue-avaliability')) {
                    $container.append(
                        '<div class="ocd-close availability-close" tabindex="0" aria-label="Close" role="button"><i class="icon icon-close" aria-hidden="true" tabindex="-1"></i></div>'
                    );
                }

                if ($closeIcon) {
                    $container.prepend($closeIcon);
                }
            }
            $('.newsletter-flag').animate(
                {
                    scrollTop: 0
                },
                0
            );
            captcha.resetCaptcha($form[0]);
        },
        error: response => {
            $('<div class="status message error-form">' + Resources.NEWSLETTER_ERROR + '</div>').insertBefore(
                $flyinContainer.find(insertBeforeSelector)
            );
            captcha.resetCaptcha($form[0]);
        },
        complete: () => progress.hide()
    });
}

function initOffCanvasDialog($flyinFlag) {
    // ADA: Set Up the Initial Fly-In Flag
    // Note that there are two fly-in flags on the page:
    // one is visible when the fly-in is closed, the other - when it is open.
    const $initialFlyinFlag = $('.flyin-newsletter-signup-flag');
    $initialFlyinFlag.attr('tabindex', '0').attr('role', 'button');
    $initialFlyinFlag
        .closest('.fly-in-flag')
        .find('.icon-close')
        .on('keydown', function (e) {
            if (e.which === keyCodes.ENTER) {
                $(this).click();
            }
        });

    var dialog = offcanvasdialog.init(
        'flyin-newsletter-signup-flag',
        {
            overlay: true,
            preventScroll: true,
            contentStyle: 'overlaid',
            position: getFlyinPosition($flyinFlag),
            closeOnX: true,
            reloadContentAlways: true,
            additionalClass: 'newsletter-flag',
            layoutSideButton: $flyinFlag,
            hideOriginalSideButton: navigator.appVersion.indexOf('Win') >= 0,
            closeIconClass: 'icon-close-thin'
        },
        function ($triggerButton, $flyinContainer) {
            const $closeFlag = $flyinContainer.find('.fly-in-flag');
            const $closeFlagIcon = $closeFlag.find('.icon-close');
            const $closeFlagText = $closeFlag.find('.fylin-link');
            const $closeIcon = $flyinContainer.find('.ocd-close');
            $closeIcon.appendTo('.signup-header');
            $flyinFlag.removeClass('open-animation').addClass('no-open-animation');
            $('.fylin-link').attr('aria-expanded', 'true');
            $closeFlag.addClass('layout-side-button');

            // ADA: Set Up Navigation Order
            const $tabbableFormElements = $flyinContainer.find('.newsletter-form').findTabbable();

            $tabbableFormElements.find('.subscribe-now').focus();

            $tabbableFormElements.first().on('keydown', function (e) {
                if (e.which === keyCodes.TAB && e.shiftKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    $closeFlagText.focus();
                }
            });

            $tabbableFormElements.last().on('keydown', function (e) {
                if (e.which === keyCodes.TAB && !e.shiftKey) {
                    $closeIcon.focus();
                }
            });

            $closeIcon.on('keydown', function (e) {
                if (e.which === keyCodes.TAB) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (e.shiftKey) {
                        $tabbableFormElements.last().focus();
                    } else {
                        $closeFlagIcon.focus();
                    }
                }
            });

            $closeFlagIcon.on('keydown', function (e) {
                if (e.which === keyCodes.TAB) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (e.shiftKey) {
                        $closeIcon.focus();
                    } else {
                        $closeFlagText.focus();
                    }
                } else if (e.which === keyCodes.ENTER) {
                    $(this).click();
                }
            });

            $closeFlagText.on('keydown', function (e) {
                if (e.which === keyCodes.TAB) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (e.shiftKey) {
                        $closeFlagIcon.focus();
                    } else {
                        $tabbableFormElements.first().focus();
                    }
                }
            });

            $flyinContainer.find('button[type="button"], input[type="submit"]').on('click', e => {
                e.preventDefault();
                validateNewsletterFlyinForm(
                    $flyinContainer,
                    e,
                    $closeIcon,
                    true,
                    '.nl-flyin-container__form',
                    '.signup-hint .flyin-headline-2'
                );
            });

            validInputIndicator.initValidIndicatorEvent({container: $flyinContainer});
            friendlyCaptcha.init('.nlsubscribe-form-flyin .frc-captcha');
            uniform();
        }
    );

    // update the dialog position when orientation changes
    $(window).on(
        'resize orientationchange',
        debounce(() => {
            if (dialog) {
                dialog.setOptions({
                    position: getFlyinPosition($flyinFlag)
                });
            }
        }, 100)
    );
}

exports.init = () => {
    const $flyinFlag = $('.fly-in-flag');
    initFlyinFlag($flyinFlag);
    initOffCanvasDialog($flyinFlag);
};

exports.validateNewsletterFlyinForm = validateNewsletterFlyinForm;
